import { ArrowUpCircleIcon } from '@heroicons/react/24/outline';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const BackToTopButton = () => {
	const location = useLocation();
	const [isVisible, setIsVisible] = useState(false);

	// Toggle visibility based on scroll position
	const toggleVisibility = () => {
		console.log('toggle visibility');
		if (window.scrollY >= 300) {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	};

	// Scroll to the top of the page
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	useEffect(() => {
		// Add scroll event listener
		document.addEventListener('scroll', toggleVisibility);

		// Remove the event listener when the component is unmounted
		return () => {
			document.removeEventListener('scroll', toggleVisibility);
		};
	}, []);

	return (
		<div className='scroll-to-top'>
			{isVisible && (
				<div
					onClick={scrollToTop}
					className='rounded-full text-white fixed bottom-10 left-10 bg-gray-900 hover:bg-primary-500 p-3 cursor-pointer'
				>
					{/* Your icon or text to represent "Back to Top" */}
					<span>
						<ArrowUpCircleIcon className='h-5 w-5' />
					</span>
				</div>
			)}
		</div>
	);
};

export default BackToTopButton;
